/**
 * Validation schema for invoice fields
 */
export const validationSchema = {
    customerid: (value) => {
        if (!value) return 'Kund måste väljas';
        return null;
    },

    invoiceNumber: (value) => {
        // Optional field
        if (value && value.length > 50) return 'Fakturanummer får max vara 50 tecken';
        return null;
    },

    invoiceDate: (value) => {
        if (!value) return 'Fakturadatum krävs';
        if (!(value instanceof Date) || isNaN(value.getTime())) {
            return 'Ogiltigt datum';
        }
        return null;
    },

    dueDate: (value, allData) => {
        if (!value) return 'Förfallodatum krävs';
        if (!(value instanceof Date) || isNaN(value.getTime())) {
            return 'Ogiltigt datum';
        }
        if (allData?.invoiceDate && value < allData.invoiceDate) {
            return 'Förfallodatum måste vara efter fakturadatum';
        }
        return null;
    },

    currency: (value) => {
        if (!value) return 'Valuta måste väljas';
        const validCurrencies = ['SEK', 'EUR', 'USD', 'NOK', 'DKK'];
        if (!validCurrencies.includes(value)) {
            return 'Ogiltig valuta';
        }
        return null;
    },

    items: (value) => {
        if (!value || !Array.isArray(value) || value.length === 0) {
            return 'Minst en artikel måste läggas till';
        }
        return null;
    },

    notes: (value) => {
        if (value && value.length > 2000) {
            return 'Anteckningar får max vara 2000 tecken';
        }
        return null;
    }
};

export const getValidationState = (fieldName, validationErrors = {}, touchedFields = {}) => {
    const hasError = validationErrors[fieldName] && touchedFields[fieldName];

    return {
        isInvalid: Boolean(hasError),
        error: hasError ? validationErrors[fieldName] : null
    };
};